import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "text-xs text-gray-600" }
const _hoisted_3 = {
  key: 0,
  class: "divide-y divide-gray-200"
}
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = { class: "font-medium text-gray-800" }
const _hoisted_6 = { class: "text-xs text-gray-500 truncate" }
const _hoisted_7 = { class: "text-right whitespace-nowrap" }
const _hoisted_8 = { class: "font-semibold text-gray-800" }
const _hoisted_9 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_10 = {
  key: 1,
  class: "px-4 py-2 text-sm text-red-700 bg-red-100 border-t border-red-200"
}
const _hoisted_11 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-stretch sm:items-center justify-center sm:p-6"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
const _hoisted_13 = { class: "relative w-full h-full sm:h-auto sm:max-h-full sm:max-w-3xl bg-white sm:rounded-xl shadow-xl flex flex-col overflow-hidden" }
const _hoisted_14 = { class: "px-4 py-3 sm:px-6 sm:py-4 border-b border-gray-200" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-base sm:text-lg font-semibold text-gray-800" }, "Notas fiscais de pallet", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs sm:text-sm text-gray-500" }, " Marque as notas que serão descarregadas. A quantidade vem com o saldo da nota; altere se for descarregar menos. ", -1)
const _hoisted_17 = { class: "flex items-center justify-between gap-2 mt-2 text-xs sm:text-sm" }
const _hoisted_18 = { class: "text-gray-600" }
const _hoisted_19 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-2" }
const _hoisted_20 = ["onKeydown"]
const _hoisted_21 = ["onKeydown"]
const _hoisted_22 = ["onKeydown"]
const _hoisted_23 = { class: "flex justify-end gap-2 mt-2" }
const _hoisted_24 = { class: "flex-1 overflow-y-auto" }
const _hoisted_25 = {
  key: 0,
  class: "flex items-center gap-3 px-4 py-2 text-sm text-gray-700 border-b border-gray-200 bg-gray-100 cursor-pointer"
}
const _hoisted_26 = ["checked"]
const _hoisted_27 = {
  key: 1,
  class: "px-4 py-8 text-center text-gray-500"
}
const _hoisted_28 = {
  key: 2,
  class: "px-4 py-8 text-center text-gray-500"
}
const _hoisted_29 = {
  key: 3,
  class: "divide-y divide-gray-200"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["checked", "onChange"]
const _hoisted_32 = { class: "flex-1 min-w-0" }
const _hoisted_33 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_34 = { class: "font-semibold text-gray-800 text-sm sm:text-base" }
const _hoisted_35 = { class: "text-sm text-gray-600 whitespace-nowrap" }
const _hoisted_36 = { class: "text-xs text-gray-500" }
const _hoisted_37 = { class: "text-sm text-gray-700 break-words" }
const _hoisted_38 = {
  key: 0,
  class: "text-xs text-gray-500 break-words"
}
const _hoisted_39 = {
  key: 1,
  class: "text-xs text-gray-500"
}
const _hoisted_40 = {
  key: 0,
  class: "flex items-center gap-2 mt-2 pl-8"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "text-xs text-gray-600 whitespace-nowrap" }, "Qtd. a descarregar", -1)
const _hoisted_42 = ["onUpdate:modelValue", "max"]
const _hoisted_43 = {
  key: 0,
  class: "text-xs text-red-700"
}
const _hoisted_44 = {
  key: 4,
  class: "px-4 py-4 text-center border-t border-gray-200"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "px-4 py-3 sm:px-6 border-t border-gray-200 bg-gray-100" }
const _hoisted_47 = { class: "flex items-center justify-between gap-2 mb-2 sm:mb-0 sm:hidden text-sm text-gray-700" }
const _hoisted_48 = { class: "flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-2" }
const _hoisted_49 = { class: "flex flex-wrap gap-x-4" }
const _hoisted_50 = { class: "flex items-center gap-3" }
const _hoisted_51 = { class: "hidden sm:inline text-sm text-gray-700" }
const _hoisted_52 = ["disabled"]

import { computed, inject, onMounted, onUnmounted, ref, watch } from "vue";
import store from "@/store";
import helpers from "@/helpers";
import { getThemeColor } from "@/branding";
import {
  FormValidatedErrorsKey,
  FormValidatedUpdateKey,
  FormValidatedValuesKey,
} from "@/types/inject";
import {
  FiltrosNotasPallet,
  NotaPallet,
  NotaPalletSelecionada,
  NotasPalletResposta,
} from "@/types/nota_pallet";
import { ObjetoPadrao } from "@/types/objetopadrao";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotasPallet',
  props: {
  agendamentoUkey: {
    type: String,
    default: "",
  },
  permiteTrocarTipo: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const theme = getThemeColor();

const values = inject(FormValidatedValuesKey, {});
const errors = inject(FormValidatedErrorsKey, {});
const onUpdate = inject(FormValidatedUpdateKey);

const aberto = ref(false);
const filtrosAbertos = ref(false);
const carregando = ref(false);
const carregandoMais = ref(false);
const filtros = ref<FiltrosNotasPallet>({ motorista: "", placa: "", cliente: "" });
const rascunho = ref<Record<string, NotaPalletSelecionada>>({});

const notasPallet = computed<NotasPalletResposta>(() => store.state.notas_pallet);
const perfilInterno = computed(() => notasPallet.value.perfil == "interno");
const exibeMotorista = computed(() => notasPallet.value.perfil != "motorista");

const selecionadas = computed<NotaPalletSelecionada[]>(
  () => (values["notas"] ?? []) as NotaPalletSelecionada[]
);
const erroNotas = computed(() => errors["notas"] ?? "");

const somaQuantidade = (notas: { quantidade: number }[]) =>
  notas.reduce((total, nota) => total + Number(nota.quantidade || 0), 0);

const formataQuantidade = (valor: number) => Number(valor || 0).toLocaleString("pt-BR");

const totalSelecionado = computed(() => somaQuantidade(selecionadas.value));
const itensRascunho = computed(() => Object.values(rascunho.value));
const quantidadeRascunho = computed(() => itensRascunho.value.length);
const totalRascunho = computed(() => somaQuantidade(itensRascunho.value));

const quantidadeInvalida = (nota: NotaPalletSelecionada) =>
  !(Number(nota.quantidade) > 0) || Number(nota.quantidade) > Number(nota.saldo);

const podeConfirmar = computed(
  () =>
    itensRascunho.value.length > 0 &&
    itensRascunho.value.every((nota) => !quantidadeInvalida(nota))
);

const todasSelecionadas = computed(
  () =>
    notasPallet.value.notas.length > 0 &&
    notasPallet.value.notas.every((nota) => !!rascunho.value[nota.j11_ukey])
);

const selecionar = (nota: NotaPallet) => {
  rascunho.value = {
    ...rascunho.value,
    [nota.j11_ukey]: { ...nota, saldo: Number(nota.quantidade), quantidade: Number(nota.quantidade) },
  };
};

const remover = (j11Ukey: string) => {
  const copia = { ...rascunho.value };
  delete copia[j11Ukey];
  rascunho.value = copia;
};

const alternar = (nota: NotaPallet) => {
  if (rascunho.value[nota.j11_ukey]) {
    remover(nota.j11_ukey);
    return;
  }

  selecionar(nota);
};

const alternarTodas = () => {
  if (todasSelecionadas.value) {
    notasPallet.value.notas.forEach((nota) => remover(nota.j11_ukey));
    return;
  }

  notasPallet.value.notas
    .filter((nota) => !rascunho.value[nota.j11_ukey])
    .forEach((nota) => selecionar(nota));
};

const abrir = () => {
  rascunho.value = selecionadas.value.reduce(
    (mapa, nota) => ({ ...mapa, [nota.j11_ukey]: { ...nota } }),
    {} as Record<string, NotaPalletSelecionada>
  );
  atualizaSaldosDoRascunho();
  aberto.value = true;
};

const LIMITE_OBSERVACOES = 240;

const textoNotas = (notas: NotaPalletSelecionada[]) => {
  const numeros = Array.from(new Set(notas.map((nota) => String(nota.numero).trim())));

  if (numeros.length == 0) {
    return "";
  }

  return `Notas: ${numeros.join(", ")}`.slice(0, LIMITE_OBSERVACOES);
};

const confirmar = () => {
  if (!podeConfirmar.value) {
    return;
  }

  const notas = itensRascunho.value.map((nota) => ({ ...nota, quantidade: Number(nota.quantidade) }));
  typeof onUpdate === "function" &&
    onUpdate({ notas: notas as unknown as ObjetoPadrao[], observacoes: textoNotas(notas) });
  aberto.value = false;
};

const trocarTipoProduto = () => {
  aberto.value = false;
  typeof onUpdate === "function" &&
    onUpdate({ tipo_produto_a_ser_descarregado: "", notas: [] });
};

const filtrosDaBusca = () => ({ ...filtros.value, agendamento_ukey: props.agendamentoUkey });

const atualizaSaldosDoRascunho = () => {
  notasPallet.value.notas.forEach((nota) => {
    const selecionada = rascunho.value[nota.j11_ukey];
    if (selecionada) {
      selecionada.saldo = Number(nota.quantidade);
    }
  });
};

const buscar = async () => {
  carregando.value = true;
  try {
    await store.dispatch("buscarNotasPallet", { filtros: filtrosDaBusca(), pagina: 1 });
    atualizaSaldosDoRascunho();
  } finally {
    carregando.value = false;
  }
};

const carregarMais = async () => {
  carregandoMais.value = true;
  try {
    await store.dispatch("buscarNotasPallet", {
      filtros: filtrosDaBusca(),
      pagina: notasPallet.value.pagina + 1,
    });
    atualizaSaldosDoRascunho();
  } finally {
    carregandoMais.value = false;
  }
};

const limpar = () => {
  filtros.value = { motorista: "", placa: "", cliente: "" };
  buscar();
};

watch(aberto, (valor) => {
  document.body.style.overflow = valor ? "hidden" : "";
});

onUnmounted(() => {
  document.body.style.overflow = "";
});

onMounted(async () => {
  await buscar();

  if (notasPallet.value.ativo && selecionadas.value.length == 0) {
    abrir();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_unref(notasPallet).ativo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-full border rounded-xl overflow-hidden", _unref(erroNotas) ? 'border-red-200' : `border-${_unref(theme)}-200`])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-wrap items-center justify-between gap-2 px-4 py-3", `bg-${_unref(theme)}-50`])
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(["text-sm font-semibold", `text-${_unref(theme)}-900`])
              }, "Notas fiscais de pallet", 2),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(selecionadas).length) + " " + _toDisplayString(_unref(selecionadas).length == 1 ? "nota selecionada" : "notas selecionadas") + ", " + _toDisplayString(formataQuantidade(_unref(totalSelecionado))) + " pallets ", 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["text-sm font-semibold text-white rounded-lg px-4 py-2", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900`]),
              onClick: abrir
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "pen",
                class: "mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(selecionadas).length ? "Alterar notas" : "Selecionar notas"), 1)
            ], 2)
          ], 2),
          (_unref(selecionadas).length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selecionadas), (nota) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: nota.j11_ukey,
                    class: "flex items-center justify-between gap-3 px-4 py-2 text-sm"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, "NF " + _toDisplayString(nota.numero) + " | " + _toDisplayString(_unref(helpers).formatData(nota.emissao)), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(nota.cliente), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(formataQuantidade(nota.quantidade)) + " pallets", 1),
                      (nota.quantidade != nota.saldo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " de " + _toDisplayString(formataQuantidade(nota.saldo)) + " na nota ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(erroNotas))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(erroNotas)), 1))
            : _createCommentVNode("", true)
        ], 2),
        (_openBlock(), _createBlock(_Teleport, { to: "#modals-target" }, [
          (aberto.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _createTextVNode(" Saldo em aberto: "),
                        _createElementVNode("b", null, _toDisplayString(formataQuantidade(_unref(notasPallet).saldo_total)), 1),
                        _createTextVNode(" pallets ")
                      ]),
                      (_unref(perfilInterno))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: _normalizeClass(["sm:hidden font-semibold", `text-${_unref(theme)}-900`]),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (filtrosAbertos.value = !filtrosAbertos.value))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "filter",
                              class: "mr-1"
                            }),
                            _createTextVNode("Filtros "),
                            _createVNode(_component_font_awesome_icon, {
                              icon: "chevron-down",
                              class: "ml-1"
                            })
                          ], 2))
                        : _createCommentVNode("", true)
                    ]),
                    (_unref(perfilInterno))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["mt-2 rounded-lg p-2 sm:p-3 sm:block", [`bg-${_unref(theme)}-50`, filtrosAbertos.value ? 'block' : 'hidden']])
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtros.value.motorista) = $event)),
                              type: "text",
                              placeholder: "Nome do motorista",
                              class: "w-full text-sm border border-gray-300 rounded-md px-3 py-2",
                              onKeydown: _withKeys(_withModifiers(buscar, ["prevent"]), ["enter"])
                            }, null, 40, _hoisted_20), [
                              [_vModelText, filtros.value.motorista]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtros.value.placa) = $event)),
                              type: "text",
                              placeholder: "Placa",
                              class: "w-full text-sm border border-gray-300 rounded-md px-3 py-2",
                              onKeydown: _withKeys(_withModifiers(buscar, ["prevent"]), ["enter"])
                            }, null, 40, _hoisted_21), [
                              [_vModelText, filtros.value.placa]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtros.value.cliente) = $event)),
                              type: "text",
                              placeholder: "Cliente",
                              class: "w-full text-sm border border-gray-300 rounded-md px-3 py-2",
                              onKeydown: _withKeys(_withModifiers(buscar, ["prevent"]), ["enter"])
                            }, null, 40, _hoisted_22), [
                              [_vModelText, filtros.value.cliente]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-sm text-gray-600 hover:text-gray-800 px-3 py-2",
                              onClick: limpar
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "eraser",
                                class: "mr-1"
                              }),
                              _createTextVNode("Limpar ")
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["text-sm font-semibold text-white rounded-md px-4 py-2", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900`]),
                              onClick: buscar
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "filter",
                                class: "mr-1"
                              }),
                              _createTextVNode("Aplicar filtro ")
                            ], 2)
                          ])
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (_unref(notasPallet).notas.length > 0 && !carregando.value)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_25, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "h-5 w-5",
                            checked: _unref(todasSelecionadas),
                            onChange: alternarTodas
                          }, null, 40, _hoisted_26),
                          _createTextVNode(" Selecionar todas as carregadas ")
                        ]))
                      : _createCommentVNode("", true),
                    (carregando.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "sync-alt",
                            spin: "",
                            class: "mr-1"
                          }),
                          _createTextVNode("Carregando notas... ")
                        ]))
                      : (_unref(notasPallet).notas.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Nenhuma nota fiscal de pallet com saldo em aberto. "))
                        : (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notasPallet).notas, (nota) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: nota.j11_ukey,
                                class: _normalizeClass(["px-4 py-3", rascunho.value[nota.j11_ukey] ? `bg-${_unref(theme)}-50` : ''])
                              }, [
                                _createElementVNode("div", {
                                  class: "flex items-start gap-3 cursor-pointer",
                                  onClick: ($event: any) => (alternar(nota))
                                }, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "mt-1 h-5 w-5 flex-shrink-0 cursor-pointer",
                                    checked: !!rascunho.value[nota.j11_ukey],
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                                    onChange: ($event: any) => (alternar(nota))
                                  }, null, 40, _hoisted_31),
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("span", _hoisted_34, "NF " + _toDisplayString(nota.numero), 1),
                                      _createElementVNode("span", _hoisted_35, [
                                        _createTextVNode(" Saldo "),
                                        _createElementVNode("b", null, _toDisplayString(formataQuantidade(nota.quantidade)), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_36, "Emissão " + _toDisplayString(_unref(helpers).formatData(nota.emissao)), 1),
                                    _createElementVNode("div", _hoisted_37, _toDisplayString(nota.cliente), 1),
                                    (_unref(exibeMotorista) && nota.motorista)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Motorista: " + _toDisplayString(nota.motorista), 1))
                                      : _createCommentVNode("", true),
                                    (_unref(perfilInterno) && nota.placa)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Placa: " + _toDisplayString(_unref(helpers).formatPlacaVeiculo(nota.placa)), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 8, _hoisted_30),
                                (rascunho.value[nota.j11_ukey])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      _hoisted_41,
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((rascunho.value[nota.j11_ukey].quantidade) = $event),
                                        type: "number",
                                        inputmode: "numeric",
                                        min: "1",
                                        max: nota.quantidade,
                                        class: _normalizeClass(["w-24 text-sm border rounded-md px-2 py-1 text-right", quantidadeInvalida(rascunho.value[nota.j11_ukey]) ? 'border-red-200 bg-red-100' : 'border-gray-300']),
                                        onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                      }, null, 42, _hoisted_42), [
                                        [
                                          _vModelText,
                                          rascunho.value[nota.j11_ukey].quantidade,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      (quantidadeInvalida(rascunho.value[nota.j11_ukey]))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, " Entre 1 e " + _toDisplayString(formataQuantidade(nota.quantidade)), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128))
                          ])),
                    (_unref(notasPallet).tem_mais && !carregando.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["text-sm font-semibold underline hover:opacity-80", `text-${_unref(theme)}-900`]),
                            disabled: carregandoMais.value,
                            onClick: carregarMais
                          }, [
                            (carregandoMais.value)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  icon: "sync-alt",
                                  spin: "",
                                  class: "mr-1"
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" Carregar mais notas ")
                          ], 10, _hoisted_45)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("span", null, _toDisplayString(_unref(quantidadeRascunho)) + " " + _toDisplayString(_unref(quantidadeRascunho) == 1 ? "nota" : "notas"), 1),
                      _createElementVNode("b", null, _toDisplayString(formataQuantidade(_unref(totalRascunho))) + " pallets", 1)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        (_unref(selecionadas).length > 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "text-sm text-gray-600 hover:text-gray-800 underline py-2",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (aberto.value = false))
                            }, " Cancelar "))
                          : _createCommentVNode("", true),
                        (__props.permiteTrocarTipo)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "text-sm text-gray-600 hover:text-gray-800 underline py-2",
                              onClick: trocarTipoProduto
                            }, " Não é pallet? Trocar tipo de produto "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", _hoisted_51, [
                          _createTextVNode(_toDisplayString(_unref(quantidadeRascunho)) + " " + _toDisplayString(_unref(quantidadeRascunho) == 1 ? "nota" : "notas") + ", ", 1),
                          _createElementVNode("b", null, _toDisplayString(formataQuantidade(_unref(totalRascunho))) + " pallets", 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["w-full sm:w-auto text-sm font-semibold text-white rounded-lg px-5 py-3", [
                    `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900`,
                    _unref(podeConfirmar) ? '' : 'opacity-50 cursor-not-allowed',
                  ]]),
                          disabled: !_unref(podeConfirmar),
                          onClick: confirmar
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "check",
                            class: "mr-1"
                          }),
                          _createTextVNode("Confirmar notas ")
                        ], 10, _hoisted_52)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      ]))
    : _createCommentVNode("", true)
}
}

})